import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, onlyUnauth, children }) => {
  if (onlyUnauth) {
    if (user !== null) {
      return <Navigate to="/" replace={true} />;
    } else {
      return children;
    }
  } else {
    if (user === null) {
    return <Navigate to="/login" replace={true} />
    } else {
      return children;
    }
  }
}

export default ProtectedRoute;